import { FC, ReactNode, createContext, useState } from 'react'

export interface ReadOnly {
  readOnly?: boolean
  disable: () => void
  enable: () => void
}

export const ACTIVE_CONTEXT = {
  readOnly: false,
  disable: () => {
    /* do nothing */
  },
  enable: () => {
    /* do nothing */
  },
}

export const useReadOnly = () => {
  const [readOnly, setReadOnly] = useState(false)

  const disable = () => {
    setReadOnly(false)
  }

  const enable = () => {
    setReadOnly(true)
  }

  return {
    readOnly,
    disable,
    enable,
  } as ReadOnly
}

export const ReadOnlyContext = createContext<ReadOnly>(ACTIVE_CONTEXT)

interface ReadOnlyContextProps {
  children: ReactNode
}
export const ReadOnlyProvider: FC<ReadOnlyContextProps> = ({ children }) => {
  return <ReadOnlyContext.Provider value={useReadOnly()}>{children}</ReadOnlyContext.Provider>
}
